<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M17.25 12.73L36.75 24l-19.5 11.27V12.73m-1-3.73a2 2 0 00-2 2v26a2 2 0 002 2 1.94 1.94 0 001-.28l22.5-13a2 2 0 000-3.46l-22.5-13a1.94 1.94 0 00-1-.28z"/></svg>